import { render } from "./Popover.vue?vue&type=template&id=7e23296c"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=7e23296c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/Popover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e23296c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e23296c', __exports__)) {
    api.reload('7e23296c', __exports__)
  }
  
  module.hot.accept("./Popover.vue?vue&type=template&id=7e23296c", () => {
    api.rerender('7e23296c', render)
  })

}


export default __exports__